export enum ListOperation {
  Add = 1,
  Remove = -1,
  Reorder = 0,
  Init = 1000,
  Update = 2000
}
